<template>
    <div class="skeleton-wrapper">
        <div class="skeleton line">
            <div class="wave-text">
                <span>L</span><span>o</span><span>a</span><span>d</span><span>i</span><span>n</span><span>g</span><span>.</span><span>.</span><span>.</span>
            </div>
        </div>
    </div>
</template>
<script setup>
</script>